/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/flowSelect.scss';

import React, {MouseEventHandler} from 'react';
import {AwesomeIcon, Checkbox, Link, Loader, voidFunction, WithBackground} from '@dvrd/dvr-controls';
import {EmailFlow} from "../../../util/interfaces";
import {FlowParams, getFlowParams} from "../../../util/emailStepUtil";
import {BolmateButton} from "../../controls";
import BolmateRadio from "../../controls/radio/bolmateRadio";

interface Props {
    onSelectFlow: (emailFlow: EmailFlow) => VoidFunction;
    onSubmit: MouseEventHandler;
    onClose: MouseEventHandler;
    loading: boolean;
    selectedFlow: EmailFlow | null;
    active: boolean;
}

export default function FlowSelect(props: Props) {
    const {selectedFlow, onSelectFlow, onClose, onSubmit, active, loading} = props;

    function renderFlow(flow: EmailFlow) {
        const flowParams: FlowParams | null = getFlowParams(flow),
            showPolicy = [EmailFlow.INVOICE, EmailFlow.REVIEW_INVOICE].includes(flow);
        if (!flowParams) return null;
        return (
            <div className='item-picker'
                 onClick={onSelectFlow(flow)}>
                <BolmateRadio onSelect={voidFunction} selected={flow === selectedFlow}/>
                <div className='texts-container'>
                    <label className='item-picker-title'>{flowParams.title}</label>
                    <label className='description'>{flowParams.description}</label>
                    {showPolicy && <Link className='link'
                                         route='https://partnerplatform.bol.com/nl/hulp-nodig/prestaties/beleidspunten-zelfpromotie/'>Deze
                        method is in overeenstemming met het beleid van Bol <AwesomeIcon name='external-link-alt'/></Link>}
                </div>
            </div>
        )
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='flow-select default-popup'>
                <div className='header-container'>
                    <label className='header-title'>Wat voor mail wil je toevoegen?</label>
                </div>
                <div className='body-container'>
                    <Loader active={loading}/>
                    {renderFlow(EmailFlow.INVOICE)}
                    {renderFlow(EmailFlow.REVIEW_INVOICE)}
                </div>
                <div className='footer-container'>
                    <BolmateButton onClick={onClose} label='Annuleren' secondary/>
                    <BolmateButton onClick={onSubmit} label='Kiezen' disabled={!selectedFlow}/>
                </div>
            </div>
        </WithBackground>
    )
}